import dayjs, { Dayjs } from 'dayjs';
import { DateStatus } from './types';

export function getOnSiteDetailsStatus(
  now: Dayjs,
  bookedIn?: Dayjs,
  onSite?: Dayjs
): DateStatus {
  if (!onSite && !bookedIn) return 'grey';
  if (bookedIn) {
    if (bookedIn > now && !onSite) return 'grey';
    if (bookedIn < now && !onSite) return 'amber';
  }
  if (!bookedIn && onSite) return 'green';
  if (onSite && bookedIn) {
    const isSameDate = dayjs(onSite).isSame(dayjs(bookedIn), 'date');
    if (isSameDate) return 'green';
    if (!isSameDate) return 'red';
  }
  return 'unknown';
}
